import React, {useCallback, useMemo, useRef, useState} from 'react';
import {navigateHook} from "../../../../hooks/use-navigate.js";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import typePlaceService from "../../../../services/web/type-place-service.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const initialFilter = { name: "" }

const TypePlaceList = () => {
    const navigate = navigateHook();

    const [state, setState] = useState(initialFilter)
    const [filter, setFilter] = useState({});
    const [typePlace, setTypePlace] = useState([]);

    const gridRef = useRef(null);
    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    const { isLoading } = useQuery({
        queryFn: () =>  typePlaceService.list(filter).then(({data}) => {
            setTypePlace(data.data)
            return data
        }),
        queryKey: ['typePlace', filter]
    });


    const columnDefs = [
        {
            headerName: "Nome", field: "name", flex: 1, resizable: false,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
    ];
    const onChange = ({target}) => {
        let {id, value} = target;

        setState(prev => ({...prev, [id]: value}));
    }

    const apply = useCallback(() => {
        gridRef.current?.api?.showLoadingOverlay();
        setFilter({name: state.name})
    }, [state]);

    const clearFilter = () => {
        setFilter({});
        setState(initialFilter);
    }

    const onCellClicked = ({data}) => {
        let isBlank = false;
        let urlDev = `/typePlace/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    const newTypePlace = () => {
        let isBlank = false;
        let urlDev = `/typePlace/form`;
        navigate(urlDev, isBlank);
    }

    useGlobalKey("Enter", apply)
    useGlobalKey("Escape", clearFilter)
    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Tipos de local
                </Template.Title>
                <Button onClick={() => newTypePlace()}>
                    <FaPlus/>
                    Adicionar tipo de local
                </Button>
            </Template.Header>

            <Template.Body className="flex flex-col space-y-2">
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12">
                            <div className="flex col-span-12 gap-4">
                                <InputForm classNameWrapper={"w-full"} id="name" value={state.name} onChange={onChange}
                                           label="Nome"/>
                                <div className={"flex gap-2"}>
                                    <Button title="Limpar" onClick={() => clearFilter()} target={"primary-outline"}>
                                        <FaEraser />
                                    </Button>
                                    <Button title="Buscar" onClick={() => apply(state)}>
                                        <FaSearch />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={typePlace}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={aggridUtils.defaultGridOptions()}
                                theme={theme}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default TypePlaceList;